// extracted by mini-css-extract-plugin
export default {"overlay":"Fu-z","bodyOpen":"Gu-z","content":"Hu-z","header":"Iu-z","close":"Ju-z","closeNoHeading":"Ku-z"};